/* ==========================================================================
   Basoas Collection "Todos" (templates/collection.todos.json)
   Tabs / size filter / "Mostrar más" / size quick-add / reviews carousel.
   Custom elements are guarded so loading this file from several sections is safe.
   ========================================================================== */
(function () {
  'use strict';

  function addToCart(items) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Error');
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'basoas-collection-todos' });
        }
        if (cart && typeof cart.renderContents === 'function' && res.sections) {
          if (res.items && res.items[0]) res.id = res.items[0].variant_id;
          var inner = cart.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
        return res;
      });
  }

  /* ---------- Collection: tabs, filters, show more, quick add ---------- */
  if (!customElements.get('bct-collection')) {
    customElements.define('bct-collection', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.cards = Array.from(this.querySelectorAll('[data-bct-card]'));
        this.tabs = Array.from(this.querySelectorAll('[data-bct-filter]'));
        this.cats = Array.from(this.querySelectorAll('[data-bct-cat]'));
        this.sizeSelect = this.querySelector('[data-bct-size]');
        this.familySelect = this.querySelector('[data-bct-family]');
        this.countEl = this.querySelector('[data-bct-count]');
        this.moreBtn = this.querySelector('[data-bct-more]');
        this.emptyEl = this.querySelector('[data-bct-empty]');
        this.pageSize = parseInt(this.dataset.pageSize, 10) || 16;
        this.limit = this.pageSize;
        var pressed = this.tabs.find((t) => t.getAttribute('aria-pressed') === 'true');
        this.family = pressed ? pressed.dataset.bctFilter : 'all';
        this.size = '';

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => { this.setFamily(tab.dataset.bctFilter); this.syncUrl(); });
          tab.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            e.preventDefault();
            var i = this.tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
            this.tabs[(i + this.tabs.length) % this.tabs.length].focus();
          });
        });
        if (this.familySelect) this.familySelect.addEventListener('change', () => { this.setFamily(this.familySelect.value); this.syncUrl(); });
        if (this.sizeSelect) this.sizeSelect.addEventListener('change', () => {
          this.size = this.sizeSelect.value;
          this.limit = this.pageSize;
          this.apply();
        });
        if (this.moreBtn) this.moreBtn.addEventListener('click', () => {
          this.limit += this.pageSize;
          this.apply();
        });
        this.initQuickAdd();
        // ?tipo=clasica|bambu|cortos (tab "Clave en la URL") preselects that tab; missing/invalid = current default.
        var key = (new URLSearchParams(window.location.search).get('tipo') || '').toLowerCase();
        var keyed = key && this.tabs.find((t) => t.dataset.bctKey === key);
        if (keyed) this.setFamily(keyed.dataset.bctFilter);
        else this.apply();
      }

      // Keep ?tipo= in sync with the selected tab (no reload) for refresh, back and sharing.
      syncUrl() {
        if (!window.history || !window.history.replaceState) return;
        var tab = this.tabs.find((t) => t.dataset.bctFilter === this.family);
        var url = new URL(window.location.href);
        if (tab && tab.dataset.bctKey) url.searchParams.set('tipo', tab.dataset.bctKey);
        else url.searchParams.delete('tipo');
        window.history.replaceState(window.history.state, '', url.toString());
      }

      setFamily(family) {
        if (!this.tabs.some((t) => t.dataset.bctFilter === family) && family !== 'all') return;
        this.family = family;
        this.limit = this.pageSize;
        this.tabs.forEach((t) => t.setAttribute('aria-pressed', t.dataset.bctFilter === family ? 'true' : 'false'));
        if (this.familySelect && this.familySelect.value !== family) this.familySelect.value = family;
        var hasCat = this.cats.some((c) => c.dataset.bctCat === family);
        this.cats.forEach((c) => { c.hidden = hasCat ? c.dataset.bctCat !== family : true; });
        this.apply();
      }

      apply() {
        var matches = this.cards.filter((card) => {
          if (this.family !== 'all' && card.dataset.family !== this.family) return false;
          if (this.size && (card.dataset.sizes || '').indexOf('|' + this.size + '|') === -1) return false;
          return true;
        });
        this.cards.forEach((card) => { card.hidden = true; });
        matches.forEach((card, i) => { card.hidden = i >= this.limit; });
        if (this.countEl) this.countEl.textContent = matches.length;
        if (this.moreBtn) this.moreBtn.hidden = matches.length <= this.limit;
        if (this.emptyEl) this.emptyEl.hidden = matches.length > 0;
        this.closeQuick();
      }

      initQuickAdd() {
        this.querySelectorAll('[data-bct-quick]').forEach((btn) => {
          var card = btn.closest('[data-bct-card]');
          var panel = card.querySelector('[data-bct-quick-panel]');
          if (!panel) return;
          btn.addEventListener('click', () => {
            var open = panel.hidden;
            this.closeQuick();
            if (open) {
              panel.hidden = false;
              btn.setAttribute('aria-expanded', 'true');
              var first = panel.querySelector('[data-bct-add]:not([disabled])');
              if (first) first.focus();
            }
          });
          panel.querySelector('[data-bct-quick-close]').addEventListener('click', () => {
            this.closeQuick();
            btn.focus();
          });
          panel.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') { this.closeQuick(); btn.focus(); }
          });
          panel.querySelectorAll('[data-bct-add]').forEach((size) => {
            size.addEventListener('click', () => {
              var err = panel.querySelector('[data-bct-quick-error]');
              err.hidden = true;
              size.classList.add('is-loading');
              var cart = document.querySelector('cart-drawer');
              if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
              addToCart([{ id: +size.dataset.bctAdd, quantity: 1 }])
                .then(() => this.closeQuick())
                .catch((e) => { err.textContent = e.message; err.hidden = false; })
                .finally(() => size.classList.remove('is-loading'));
            });
          });
        });
        document.addEventListener('click', (e) => {
          if (!e.target.closest('[data-bct-quick-panel]') && !e.target.closest('[data-bct-quick]')) this.closeQuick();
        });
      }

      closeQuick() {
        this.querySelectorAll('[data-bct-quick-panel]').forEach((p) => { p.hidden = true; });
        this.querySelectorAll('[data-bct-quick]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      }
    });
  }

  /* ---------- Reviews carousel ---------- */
  if (!customElements.get('bct-carousel')) {
    customElements.define('bct-carousel', class extends HTMLElement {
      connectedCallback() {
        var track = this.querySelector('[data-bct-track]');
        var prev = this.querySelector('[data-bct-prev]');
        var next = this.querySelector('[data-bct-next]');
        if (!track) return;
        var step = () => {
          var item = track.firstElementChild;
          return item ? item.getBoundingClientRect().width + 8 : track.clientWidth;
        };
        var sync = () => {
          var max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.hidden = track.scrollLeft <= 2;
          if (next) next.hidden = track.scrollLeft >= max;
        };
        if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();
      }
    });
  }

  /* ---------- Back link: use history when coming from this store ---------- */
  document.addEventListener('click', function (e) {
    var back = e.target.closest && e.target.closest('[data-bct-back]');
    if (!back) return;
    if (document.referrer && document.referrer.indexOf(location.host) !== -1 && history.length > 1) {
      e.preventDefault();
      history.back();
    }
  });
})();
